import React from 'react';
import { Building2, Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import './schrank-workspace.css';

export const floorLabel = floor => floor.etage > 0 ? `${floor.etage}. OG` : floor.etage < 0 ? `${Math.abs(floor.etage)}. UG` : 'EG';

export function SchrankLocationNav({ buildings, floors, buildingId, floorId, onBuildingChange, onFloorChange, management }) {
  const building = buildings.find(item => item.id === buildingId);
  const floor = floors.find(item => item.id === floorId);
  const orderedFloors = [...floors].sort((a, b) => b.etage - a.etage);
  return <aside className="schrank-location" aria-label="Standort auswählen">
    <div className="schrank-location-label"><Building2 size={16} /><span>Gebäude</span></div>
    <Select value={buildingId || ''} onValueChange={onBuildingChange}>
      <SelectTrigger aria-label="Gebäude auswählen" data-testid="view-building-select"><SelectValue placeholder="Gebäude wählen" /></SelectTrigger>
      <SelectContent>{buildings.map(item => <SelectItem value={item.id} key={item.id}>{item.name}</SelectItem>)}</SelectContent>
    </Select>
    {management && <div className="schrank-location-actions">
      <Button variant="ghost" size="sm" onClick={management.createBuilding} data-testid="schrank-new-building-btn"><Plus size={14} /> Gebäude</Button>
      {building && <><Button variant="ghost" size="icon" aria-label="Gebäude bearbeiten" title="Gebäude bearbeiten" onClick={() => management.editBuilding(building)}><Pencil size={14} /></Button>
      <Button variant="ghost" size="icon" aria-label="Gebäude löschen" title="Gebäude löschen" onClick={() => management.deleteBuilding(building)}><Trash2 size={14} /></Button></>}
    </div>}
    <div className="schrank-floor-label">Etagen</div>
    <nav className="schrank-floor-list" aria-label="Etagen">
      {orderedFloors.map(item => <button type="button" key={item.id} aria-current={item.id === floorId ? 'location' : undefined}
        className={`schrank-floor-option ${item.id === floorId ? 'is-active' : ''}`} onClick={() => onFloorChange(item.id)} data-testid={`floor-pill-${item.id}`}>
        <strong>{floorLabel(item)}</strong><span>{item.name}</span>
      </button>)}
    </nav>
    <div className="schrank-mobile-floors"><Select value={floorId || ''} onValueChange={onFloorChange}>
      <SelectTrigger aria-label="Etage auswählen"><SelectValue placeholder="Etage wählen" /></SelectTrigger>
      <SelectContent>{orderedFloors.map(item => <SelectItem key={item.id} value={item.id}>{floorLabel(item)} · {item.name}</SelectItem>)}</SelectContent>
    </Select></div>
    {!floors.length && <p className="schrank-location-empty">{building ? 'Noch keine Etagen vorhanden.' : 'Wähle zuerst ein Gebäude.'}</p>}
    {management && building && <div className="schrank-floor-management">
      <Button variant="outline" size="sm" onClick={management.createFloor} data-testid="schrank-new-floor-btn"><Plus size={14} /> Etage anlegen</Button>
      {floor && <div className="schrank-location-actions"><Button variant="ghost" size="sm" onClick={() => management.editFloor(floor)}><Pencil size={14} /> Bearbeiten</Button>
      <Button variant="ghost" size="icon" aria-label="Etage löschen" title="Etage löschen" onClick={() => management.deleteFloor(floor)}><Trash2 size={14} /></Button></div>}
    </div>}
  </aside>;
}
